module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hrg91/tc-custom/FC-9781645366713.jpg?1684514597073?1719602958290",
      "alt": "This image is the cover for the book Family Portraits"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Family Portraits\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After a sunset concert at the pavilion, they walked home by the harbor. Finn asked her to sit for a while with him, and then he declared himself. He took her hand and said, “Molly, my beautiful one, I have loved you from the time I moved into your family’s house. I can’t hold back any longer, and I am asking if you would consider being my wife.”")]), _c('p', [_vm._v("Her eyes widened with surprise, and then she said, “I love you more than anything, and I want to be with you forever.”")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      JoAnn Aitken\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": "8.0pt",
      "font-size": "15px",
      "font-family": "\"Arial\",\"sans-serif\"",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-family": "\"Times New Roman\",\"serif\""
    }
  }, [_vm._v("JoAnn Aitken has lived all her life in Hamilton, Ontario. She worked for many years at a local community college and has always enjoyed travel. A 2015 trip to Ireland brought together some ideas which became "), _c('em', [_vm._v("Family Portraits")]), _vm._v(". She describes writing the book as “easy” once she got started. As the end of the story approached, she found it hard to let go. She hopes her readers will feel the same.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0